import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GetDate, GetTime } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function TableRow({ item }) {
    const navigate = useNavigate();

    return (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                <Link
                    to={mkRelativeUrl(
                        `/agency/${item?.customerInfo?.agencyId}/customers/${item?.customerInfo?.id}/info`
                    )}
                    className="flex flex-col gap-1"
                >
                    <span>{item?.customerInfo?.organization}</span>
                    <span className="text-xs text-primary-500 truncate max-w-[200px]">
                        {item?.customerInfo?.email}
                    </span>
                </Link>
            </td>
            <td onClick={() => navigate(mkRelativeUrl(`/services/manage/${item?.id}/info`))}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.serviceName}
                </span>
            </td>

            <td className="text-center">
                <span>
                    {GetDate(item?.timeInitiate) || '-----'} <br />
                    <small>{GetTime(item?.timeInitiate)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeImplement) || '-----'} <br />
                    <small>{GetTime(item?.timeImplement)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeOngoing) || '-----'} <br />
                    <small>{GetTime(item?.timeOngoing)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item?.timeDone) || '------'} <br />
                    <small>{GetTime(item?.timeDone)}</small>
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetDate(item.timeUpdated) || '-----'} <br />
                    <small>{GetTime(item.timeUpdated)}</small>
                </span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'completed' ? 'text-secondary' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>
        </tr>
    );
}
function TableHeader({ initiate, implement, ongoing, done }) {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span className="">ID</span>
                </th>
                <th scope="col" className="!text-left w-42">
                    <span>Customer Info</span>
                </th>
                <th scope="col">
                    <span>Service Name</span>
                </th>

                <th scope="col" className="w-36 text-center">
                    <span>{initiate}</span>
                </th>
                <th scope="col" className="w-36 text-center">
                    <span>{implement}</span>
                </th>
                <th scope="col" className="w-36 text-center">
                    <span>{ongoing}</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>{done}</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Service Updated"
                    >
                        Updated At
                    </span>
                </th>
                <th scope="col" className="w-20 text-center">
                    <span>Status</span>
                </th>
            </tr>
        </thead>
    );
}
function TableWeb({ data, initiate, implement, ongoing, done }) {
    return (
        <div
            className={cn('agency_info_service_table pb-10 overflow-x-auto ', {
                'pb-40': data?.pendingServices?.length === 0
            })}
        >
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                />
                <tbody>
                    {data && data.services?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={8} className="!text-left">
                                No Service Found!
                            </td>
                        </tr>
                    ) : (
                        data?.services?.map((item) => <TableRow key={item?.id} item={item} />)
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
